import { faBolt } from '@fortawesome/pro-solid-svg-icons'
import { Badge } from '@/ui'
import { ReconciliationOrigin } from '@/reducers/admin/financialAccountsReducer'

export const STATEMENT_EXTRACTION_LABEL = 'Statement extraction'

/**
 * True only when the extraction pipeline authored the balances on this recon *and*
 * it actually reconciled (`status: 'complete'`). The `complete` gate keeps the ⚡
 * badge off recons extraction attempted but left unreconciled, where it otherwise
 * read as success beside a red "incomplete".
 */
export const isCompletedViaStatementExtraction = (
  reconciliation:
    | {
        origin?: ReconciliationOrigin
        status?: 'complete' | 'incomplete' | 'blocked'
      }
    | null
    | undefined
) =>
  reconciliation?.origin === ReconciliationOrigin.statementExtraction &&
  reconciliation?.status === 'complete'

const StatementExtractionBadge = ({ className }: { className?: string }) => (
  <Badge color="purple" size="sm" icon={faBolt} className={className}>
    {STATEMENT_EXTRACTION_LABEL}
  </Badge>
)

export default StatementExtractionBadge
